<template>
  <div v-if="admin" class="wrapper d-flex flex-grow-1">
    <AppSidebar />
    <div class="wrapper d-flex flex-column min-vh-100 bg-light">
      <AppHeader />
      <div class="body flex-grow-1 px-3">
        <router-view :key="$route.fullPath" />
      </div>
      <AppFooter />
    </div>
  </div>

  <div v-if="!admin">
    <div v-if="this.show_list" class="container-fluid">
      <List></List>
    </div>
    <div v-if="!this.show_list" class="container-fluid">
      <Form></Form>
    </div>
  </div>
</template>
<script>
import AppFooter from '@/components/AppFooter.vue'
import AppHeader from '@/components/AppHeader.vue'
import AppSidebar from '@/components/AppSidebar.vue'
import List from '@/views/modulo_campanhas/campanha/List.vue'
import Form from '@/views/modulo_campanhas/pedido/Form.vue'

export default {
  components: {
    List,
    Form,
    AppFooter,
    AppHeader,
    AppSidebar,
  },
  data() {
    return {
      show_list: true,
      admin: localStorage.getItem('admin') === 'true',
    }
  },
  created() {
    this.selecionaComponente()
  },
  methods: {
    selecionaComponente() {
      if (this.$route.name === 'Campanhas') {
        this.show_list = true
      } else {
        this.show_list = false
      }
    },
  },
  watch: {
    $route: {
      deep: true,
      handler: function () {
        this.selecionaComponente()
      },
    },
  },
}
</script>
